import React, {useState,} from "react";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";

import {useForm} from "react-hook-form";

import ApolloMasterIndustoryCategoryModal, {PropsModal} from "../../organism/MASTER/Apollo_MasterIndustoryCategoryModal";

export type PropsCategory = {
  productId: number             // 選択値
  industoryId: number           // 選択値
  industoryName: string         // 選択値
  industoryCategoryId: number   // 選択値
  industoryCategoryName: string // 選択値
  setIndustorycategoryId: any   // 選択値セット関数
  setIndustoryId: any           // 選択値セット関数
  setIndustoryName?: any        // 選択値セット関数
  isDisabled: boolean           // 不活化
  required: boolean             // 必須
}

interface CategoryProps {
  propsCategory: PropsCategory
};

// 状態選択セレクトボックス表示
export default function ApolloIndustoryCategory(props: CategoryProps) {

  const {
    productId,
    isDisabled,
    required,
  } = props.propsCategory;

  const {errors, setError, clearErrors} = useForm();

  const [read, setRead] = React.useState(0);
  const [industoryName, setIndustoryName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [industoryLocal, setIndustoryLocal] = useState(props.propsCategory.industoryId && props.propsCategory.industoryId);
  // setIndustoryLocal(props.propsCategory.industoryId && props.propsCategory.industoryId);

  const clearErr = () => {
    clearErrors(["industoryName", "categoryName"]);
    // 操作ログ出力用
    if (props.propsCategory.setIndustoryName) {
      props.propsCategory.setIndustoryName(industoryName);
    }

    let errFlag = false;

    if (categoryName === " " || categoryName === "") {
      setError("categoryName", {
        type: "manual",
        message: "必須選択項目です。"
      })
      errFlag = true;
    }
    if (industoryName === " " || industoryName === "") {
      setError("industoryName", {
        type: "manual",
        message: "必須選択項目です。"
      })
      errFlag = true;
    }
    if (errFlag) return;
  }

  const getIndustoryId = () => {
    return props.propsCategory.industoryId;
  }

  // 商品・業種モーダル引数
  var propsModal:PropsModal = {
    setRead : setRead,
    read : read,
    setIndustorycategoryId : props.propsCategory.setIndustorycategoryId,
    industoryId : industoryLocal ? industoryLocal : props.propsCategory.industoryId,
    setIndustoryId : props.propsCategory.setIndustoryId,
    getIndustoryId : getIndustoryId,
    productId : props.propsCategory.productId,
    setIndustoryName : setIndustoryName,
    setCategoryName : setCategoryName,
    clearErr: clearErr,
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {/* カテゴリ検索ボタン */}
        <ApolloMasterIndustoryCategoryModal propsModal={propsModal} />
      </Grid>

      <Grid item xs={12}>
        <TextField
            id="categoryName"
            name="categoryName"
            label="業種カテゴリ"
            fullWidth
            key={props.propsCategory.industoryCategoryName ? "Loaded" : "Loading"}
            helperText={errors.categoryName && errors.categoryName.message}
            error={errors.categoryName ? true : false}
            autoComplete="業種カテゴリ"
            value={categoryName ? categoryName : productId !== 0 ? props.propsCategory.industoryCategoryName : ""}
            disabled={isDisabled}
            required={required}
          />
      </Grid>

      <Grid item xs={12}>
        <TextField
            id="industoryName"
            name="industoryName"
            label="業種"
            fullWidth
            key={props.propsCategory.industoryName ? "Loaded" : "Loading"}
            helperText={errors.industoryName && errors.industoryName.message}
            error={errors.industoryName ? true : false}
            autoComplete="業種"
            value={industoryName ? industoryName : productId !== 0 ? props.propsCategory.industoryName : ""}
            disabled={isDisabled}
            required={required}
          />
      </Grid>
    </Grid>
  )
}
